// Kostensoort voor inkoopfactuurregels (spiegelt de Prisma-enum
// InkoopKostensoort). Leaf-module zonder eigen imports zodat zowel
// `inkoop.ts` als `inkoop-toewijzing.ts` (FO-147) erop kunnen leunen zonder
// circulaire import; de publieke naam blijft via de re-export in `inkoop.ts`
// en de barrel gewoon `@streep/types`.

export const INKOOP_KOSTENSOORT = [
  'OPLEIDING',
  'ELEKTRONICA',
  'GEREEDSCHAP',
  'KLEDING',
  // FO-052 P4 (batch-16) — kosten op medewerker: extra categorieën.
  'DECLARATIE',
  'VEILIGHEID',
  // FO-320 (batch-36) — materieel-kostensoorten (voertuigen/karren).
  'ONDERHOUD_REPARATIE',
  'BANDEN',
  'BRANDSTOF',
  'VERZEKERING',
  'LEASE_AFSCHRIJVING',
  'KEURING',
  'SCHADE_EIGEN_RISICO',
  'MODULES_LAYINS',
  'OVERIG',
] as const
export type InkoopKostensoort = (typeof INKOOP_KOSTENSOORT)[number]

export const INKOOP_KOSTENSOORT_LABELS: Record<InkoopKostensoort, string> = {
  OPLEIDING: 'Opleiding',
  ELEKTRONICA: 'Elektronica',
  GEREEDSCHAP: 'Gereedschap',
  KLEDING: 'Kleding',
  DECLARATIE: 'Declaratie',
  VEILIGHEID: 'Veiligheid',
  ONDERHOUD_REPARATIE: 'Onderhoud & reparatie',
  BANDEN: 'Banden',
  BRANDSTOF: 'Brandstof',
  VERZEKERING: 'Verzekering',
  LEASE_AFSCHRIJVING: 'Lease/afschrijving',
  KEURING: 'Keuring (APK e.d.)',
  SCHADE_EIGEN_RISICO: 'Schade/eigen risico',
  MODULES_LAYINS: 'Modules/lay-ins',
  OVERIG: 'Overig',
}
